/* eslint-disable @typescript-eslint/camelcase */
import { all, put, takeLatest } from 'redux-saga/effects';
import i18n from 'i18n';
import { messagesRequest } from 'modules/messages/actions';
import { getEnvironmentRequest } from 'modules/environments/actions';
import { getClientByIdRequest } from 'modules/clients/actions';
import endpoints, { api } from './endpoints';
import {
  getClientMaintenanceFulfilled,
  getClientMaintenanceHistoryFulfilled,
  getClientMaintenanceHistoryRejected,
  getClientMaintenanceHistoryRequest,
  getClientMaintenanceRejected,
  getClientMaintenanceRequest,
  getEnvironmentMaintenanceFulfilled,
  getEnvironmentMaintenanceHistoryFulfilled,
  getEnvironmentMaintenanceHistoryRejected,
  getEnvironmentMaintenanceHistoryRequest,
  getEnvironmentMaintenanceRejected,
  getEnvironmentMaintenanceRequest,
  retrieveClientMaintenanceHistoryFulfilled,
  retrieveClientMaintenanceHistoryRejected,
  retrieveClientMaintenanceHistoryRequest,
  retrieveEnvironmentMaintenanceHistoryFulfilled,
  retrieveEnvironmentMaintenanceHistoryRejected,
  retrieveEnvironmentMaintenanceHistoryRequest,
  setClientMaintenanceFulfilled,
  setClientMaintenanceRejected,
  setClientMaintenanceRequest,
  setEnvironmentMaintenanceFulfilled,
  setEnvironmentMaintenanceRejected,
  setEnvironmentMaintenanceRequest,
} from './actions';

function* getEnvironmentMaintenanceRequestSaga({ payload }) {
  const { id } = payload;

  try {
    const { data } = yield api.get({
      url: endpoints.getEnvironmentMaintenance(id),
    });

    return yield put(getEnvironmentMaintenanceFulfilled(data));
  } catch (error) {
    return yield put(getEnvironmentMaintenanceRejected());
  }
}

function* getClientMaintenanceRequestSaga({ payload }) {
  const { id } = payload;

  try {
    const { data } = yield api.get({
      url: endpoints.getClientMaintenance(id),
    });

    return yield put(getClientMaintenanceFulfilled(data));
  } catch (error) {
    return yield put(getClientMaintenanceRejected());
  }
}

function* setEnvironmentMaintenanceRequestSaga({ payload }) {
  const { id, values } = payload;

  try {
    yield api.put({
      url: endpoints.setEnvironmentMaintenance(id),
      data: values,
    });

    return yield all([
      put(setEnvironmentMaintenanceFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('MAINTENANCE_SET_SUCCESSFULLY_KEY'),
        })
      ),
      put(getEnvironmentRequest({ id, skipProvider: true })),
      put(getEnvironmentMaintenanceRequest({ id })),
      put(
        getEnvironmentMaintenanceHistoryRequest({ id, query: { limit: 500 } })
      ),
    ]);
  } catch (error) {
    return yield put(setEnvironmentMaintenanceRejected());
  }
}

function* setClientMaintenanceRequestSaga({ payload }) {
  const { id, values } = payload;

  try {
    yield api.put({
      url: endpoints.setClientMaintenance(id),
      data: values,
    });

    return yield all([
      put(setClientMaintenanceFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('MAINTENANCE_SET_SUCCESSFULLY_KEY'),
        })
      ),
      put(getClientByIdRequest({ id })),
      put(getClientMaintenanceRequest({ id })),
      put(getClientMaintenanceHistoryRequest({ id, query: { limit: 500 } })),
    ]);
  } catch (error) {
    return yield put(setClientMaintenanceRejected());
  }
}

function* getEnvironmentMaintenanceHistoryRequestSaga({ payload }) {
  const { id, query } = payload;

  try {
    const { data } = yield api.get({
      url: endpoints.getEnvironmentMaintenanceHistory(id, query),
    });

    return yield put(getEnvironmentMaintenanceHistoryFulfilled(data));
  } catch (error) {
    return yield put(getEnvironmentMaintenanceHistoryRejected());
  }
}

function* getClientMaintenanceHistoryRequestSaga({ payload }) {
  const { id, query } = payload;

  try {
    const { data } = yield api.get({
      url: endpoints.getClientMaintenanceHistory(id, query),
    });

    return yield put(getClientMaintenanceHistoryFulfilled(data));
  } catch (error) {
    return yield put(getClientMaintenanceHistoryRejected());
  }
}

function* retrieveEnvironmentMaintenanceHistoryRequestSaga({ payload }) {
  const { id, request_uuid } = payload;

  try {
    const { data } = yield api.get({
      url: endpoints.retrieveEnvironmentMaintenanceHistory(id, request_uuid),
    });

    return yield put(retrieveEnvironmentMaintenanceHistoryFulfilled(data));
  } catch (error) {
    return yield put(retrieveEnvironmentMaintenanceHistoryRejected());
  }
}

function* retrieveClientMaintenanceHistoryRequestSaga({ payload }) {
  const { id, request_uuid } = payload;

  try {
    const { data } = yield api.get({
      url: endpoints.retrieveClientMaintenanceHistory(id, request_uuid),
    });

    return yield put(retrieveClientMaintenanceHistoryFulfilled(data));
  } catch (error) {
    return yield put(retrieveClientMaintenanceHistoryRejected());
  }
}

export default all([
  takeLatest(
    getEnvironmentMaintenanceRequest,
    getEnvironmentMaintenanceRequestSaga
  ),
  takeLatest(getClientMaintenanceRequest, getClientMaintenanceRequestSaga),
  takeLatest(
    setEnvironmentMaintenanceRequest,
    setEnvironmentMaintenanceRequestSaga
  ),
  takeLatest(setClientMaintenanceRequest, setClientMaintenanceRequestSaga),
  takeLatest(
    getEnvironmentMaintenanceHistoryRequest,
    getEnvironmentMaintenanceHistoryRequestSaga
  ),
  takeLatest(
    getClientMaintenanceHistoryRequest,
    getClientMaintenanceHistoryRequestSaga
  ),
  takeLatest(
    retrieveEnvironmentMaintenanceHistoryRequest,
    retrieveEnvironmentMaintenanceHistoryRequestSaga
  ),
  takeLatest(
    retrieveClientMaintenanceHistoryRequest,
    retrieveClientMaintenanceHistoryRequestSaga
  ),
]);
